import React, { useState } from 'react';
import Header from './Header';
import SideNav from './SideNav';
import Footer from './Footer';

const Layout = ({ children, showLayout = true }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  // If showLayout is false (e.g., for login page), render children without layout
  if (!showLayout) {
    return <>{children}</>;
  }

  return (
    <div className="h-screen bg-gray-50 font-poppins flex flex-col">
      {/* Fixed Header */}
      <Header onMenuToggle={handleMenuToggle} isMenuOpen={isMenuOpen} onSidebarToggle={handleSidebarToggle} isSidebarCollapsed={isSidebarCollapsed} />
      
      <div className="flex flex-1 overflow-hidden">
        {/* Fixed Sidebar */}
        <SideNav isOpen={isMenuOpen} onClose={handleMenuClose} isCollapsed={isSidebarCollapsed} />
        
        {/* Scrollable Main content area */}
        <div className={`flex-1 flex flex-col transition-all duration-300}`}>
          {/* Scrollable Main content */}
          <main className="flex-1 overflow-y-auto px-3 sm:px-3 lg:px-3 py-3">
            <div className="">
              {children}
            </div>
          </main>
          
          {/* Fixed Footer */}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;

